import createLucideIcon from '../createLucideIcon';

const PackageSearch = createLucideIcon('PackageSearch', [
  [
    'path',
    {
      d: 'M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14',
      key: 'e7tb2h',
    },
  ],
  ['path', { d: 'M16.5 9.4 7.55 4.24', key: '10qotr' }],
  ['polyline', { points: '3.29 7 12 12 20.71 7', key: 'ousv84' }],
  ['line', { x1: '12', x2: '12', y1: '22', y2: '12', key: 'a4e8g8' }],
  ['circle', { cx: '18.5', cy: '15.5', r: '2.5', key: 'b5zd12' }],
  ['path', { d: 'M20.27 17.27 22 19', key: '1l4muz' }],
]);

export default PackageSearch;
